module.exports = __webpack_public_path__ + "img/mrny.87adc48e.png";